import { Component, input, OnInit, signal } from '@angular/core';
import { DamageClaim } from 'src/app/models/damage-claim.model';
import { CoreService } from 'src/app/services/core/core.service';

@Component({
  selector: 'app-damage-claims-card',
  templateUrl: './damage-claims-card.component.html',
  styleUrls: ['./damage-claims-card.component.scss'],
  standalone: false
})
export class DamageClaimsCardComponent implements OnInit {

  accidentClaims = input.required<DamageClaim[]>();

  isMobileApp = signal<boolean>(false);
  constructor(private readonly coreService: CoreService) { }

  ngOnInit() { }
  ionViewWillEnter()
  {
    this.isMobileApp.set(this.coreService.isMobileApp);
  }

}
